
import { Address } from "../../Models/Address";
import { formatPostalCode } from "../../Utils/DataFormatters";
import BlockedAction from "../BlockedAction/BlockedAction";

type AddressItemProps = {
  address: Address;
  index: number;
  onEdit: (address: Address) => void;
  onDelete: (address: Address) => void;
  isDeleting?: boolean;
}

const AddressItem = ({ address, index, onEdit, onDelete, isDeleting = false }: AddressItemProps) => {

  const handleEdit = () => {
    onEdit(address);
  };

  const canDelete = address.canDelete ?? false;

  const handleDelete = () => {
    if (!canDelete) {
      return;
    }

    onDelete(address);
  };

  return (
    <div className="border border-primary-600 bg-primary-50 border-l-4 rounded-xs px-6 py-2">
      <div className="flex justify-between">
        <h4 className="font-semibold text-gray-700">{"Endereço"} {index + 1}</h4>
      </div>
      <p className="text-sm text-gray-500 mt-2">
        {address.street}, {address.number}
      </p>
      <p className="text-sm text-gray-500">
        {"Bairro"}: {address.neighborhood}
      </p>
      <p className="text-sm text-gray-500">
        {"Cidade"}: {address.city}/{address.state}
      </p>
      <p className="text-sm text-gray-500">
        {"CEP"}: {formatPostalCode(address.postalCode)}
      </p>
      {address.complement &&
        <p className="text-sm text-gray-500">{"Complemento"}: {address.complement}</p>
      }
      <div className="flex justify-end gap-3">
        <button
          className="text-sm font-bold text-primary-600 hover:text-primary-700"
          onClick={handleEdit}
          disabled={isDeleting}
        >
          {"EDITAR"}
        </button>
        {canDelete ? (
          <button
            className={`text-sm font-bold ${
              isDeleting
                ? "text-gray-300 cursor-not-allowed"
                : "text-primary-600 hover:text-primary-700"
            }`}
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {"EXCLUIR"}
          </button>
        ) : (
          <BlockedAction
            label={"Excluir"}
            reason={"Este endereço não pode ser excluído porque está vinculado a pedidos."}
            className="text-sm font-bold text-gray-300"
            plain
          >
            {"EXCLUIR"}
          </BlockedAction>
        )}
      </div>
    </div>
  );
}

export default AddressItem;
